'use client';

import { usePromptTrigger } from '@/hooks/usePromptTrigger';

/**
 * Fires the prompt-counter increment for a home page view. Home uses
 * a time-based debounce (not slug dedupe) because there's a single
 * home URL — see HOME_VIEW_DEBOUNCE_MS. Renders nothing.
 *
 * No return-URL is passed because the home surface's review CTA
 * navigates to a generic `/review` (no building slug in scope), per
 * spec.
 */
export function HomePromptTrigger() {
  // The slug arg is required by the hook signature. Home dedupes by
  // time so the value doesn't matter — we pass a stable string.
  usePromptTrigger('home', 'home');
  return null;
}
